var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('cmp-header'),_c('nav-header',{ref:"nav_header"}),_c('about-pn'),_c('star-product'),_c('company-news'),_c('cooperate'),_c('business'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }